import Route from '@ember/routing/route';

export default class CourseLoadingRoute extends Route {}
